var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center justify-content-center h-100"},[_c('fa-icon',{staticClass:"text-muted",attrs:{"size":"5x","icon":['fas', 'ban']}}),_c('h1',{staticClass:"mt-4 text-muted"},[_vm._v("Forbidden")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }